// eslint-disable-next-line no-unused-vars
import { motion } from 'framer-motion'
import { XCircle } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

function PaymentCancelPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-red-200 flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <Card className="shadow-2xl rounded-2xl">
          <CardContent className="flex flex-col items-center text-center space-y-6 p-8">
            <motion.div
              initial={{ rotate: 15 }}
              animate={{ rotate: 0 }}
              transition={{ type: 'spring', stiffness: 180 }}
            >
              <XCircle className="w-20 h-20 text-red-600" />
            </motion.div>

            <h2 className="text-3xl font-extrabold text-red-700">Payment Cancelled</h2>

            <p className="text-gray-700">
              Oops! Your payment didn’t go through. You can try again or reach out to our support
              team for help.
            </p>

            <div className="flex space-x-4 mt-4">
              <Button onClick={() => navigate('/')} className="px-6 py-2">
                Retry Payment
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/business/support')}
                className="px-6 py-2"
              >
                Contact Support
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  )
}

export default PaymentCancelPage
